<template>
  <div class="header">
    <img @click="selctedView('0')" src="./assets/tab1_logo.png" class="headerlogo" />
    <div class="headerframe">
      <div class="customerservice" @click="toCustomerService">
        <img src="./assets/customerservice-fill@2x.png" alt="">
      </div>
      <!-- 点击 -->
      <div class="orderBtns">
        <el-button id="HomeorderBtn" class="orderBtn" color="#6B834B" size="large" round @mouseout="goOrders" @mouseover="goOrder">按此下單</el-button>
        <div id="trangle" class="trangle" style="display: none;position: absolute;top:79px;margin-left: 60px;"></div>
        <div id="showCode" style="display: none;position: absolute;top:87px;margin-left: -20px;width:163px;height:163px;background:white;border-radius: 5px; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
          <qrcode-vue class="qrCode" value="https://www.numatch.com.hk/oae/#/homePage" width="400" height="400" level="H" style="width:150px;height:150px;margin-top:6px;" />
        </div>
      </div>
      <div>{{onRoutes}}</div>
      <div class="btnFrame" @click="selctedView('2')">
        <div v-if="activeIndex == '2'" class="selectedLine" style="opacity: 0;"></div>
        <div :class="activeIndex == '2' ? 'btnNameSelected' : 'btnName'">成為會員</div>
        <div v-if="activeIndex == '2'" class="selectedLine"></div>
      </div>
      <div class="btnFrame" @click="selctedView('1')">
        <div v-if="activeIndex == '1'" class="selectedLine" style="opacity: 0;"></div>
        <div :class="activeIndex == '1' ? 'btnNameSelected' : 'btnName'">創意中餐</div>
        <div v-if="activeIndex == '1'" class="selectedLine"></div>
      </div>
      <div class="btnFrame" @click="selctedView('0')">
        <div v-if="activeIndex == '0'" class="selectedLine" style="opacity: 0;"></div>
        <div :class="activeIndex == '0' ? 'btnNameSelected' : 'btnName'">首頁</div>
        <div v-if="activeIndex == '0'" class="selectedLine"></div>
      </div>
    </div>
  </div>
  <router-view style="position:absolute;top:0;z-index:200;" />
</template>

<script>
import {computed, ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import QrcodeVue from "qrcode.vue";
export default {
  name: "App",
  components: {
    QrcodeVue
  },
  setup() {
    const userRouter = useRouter();
    const activeIndex = ref('-1');
    const route = useRoute()
    const toCustomerService = () => {
      window.open('https://cc.creitsm.com/yc-media/chat/web.html?channelKey=numatch&keyCode=3', '_blank')
    }
    watch(() => route.name,(newValue)=> {
        if (newValue == 'Designfood') {
        activeIndex.value = '1'
      } else if (newValue == 'Home') {
        activeIndex.value = '0'
      } else {
        activeIndex.value = '2'
      }
    },{ immediate: true })
    onMounted(()=>{
      setTimeout(() => {
        let name = userRouter.currentRoute._rawValue.name
      if (name == 'Designfood') {
        activeIndex.value = '1'
      } else if (name == 'Home') {
        activeIndex.value = '0'
      } else {
        activeIndex.value = '2'
      }
      }, 100);
    })

    const goOrder = () =>{
      let a = document.getElementById('showCode')
      a.style.display = 'block'
      let b = document.getElementById('trangle')
      b.style.display = 'block'
    };
    const goOrders = ()=>{
      let a = document.getElementById('showCode')
      a.style.display = 'none'
      let b = document.getElementById('trangle')
      b.style.display = 'none'
    }

    const selctedView = (index) =>{
      if (activeIndex.value == index) return
      activeIndex.value = index
      userRouter.push({
          path: (index == 0) ? "/home" : (index == 1) ? '/designfood' : '/register',
          query: {},
        });
    };
        const onRoutes = computed(() => {
            return userRouter.path;
        });

    return {
      userRouter,
      toCustomerService,
      goOrders,
      goOrder,
      selctedView,
      activeIndex,
      onRoutes
    };
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 90px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0px;
  left: 0px;
  z-index: 999;
}
.headerlogo {
  margin-left: 19%;
  width: 198px;
  height: 72px;
  cursor: pointer; 
  cursor: hand;
}
.headerframe {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-right: 20%;
  width: 552px;
  height: 100%;
}
.customerservice {
  margin-left: 20px;
  img {
    width: 40px;
  }
}
.orderBtn{
  width: 123px;
  height: 49px;
  border-radius: 24px !important;
}
#HomeorderBtn{
  :deep(.el-button:hover){
  background: #8BA962;
}
}
:deep(.el-button>span) {
  color: white;
  font-size: 18px;
}

.btnFrame {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  margin-right: calc(100% / 305 * 11);
  width: 123px;
  height: 65px;
  justify-content: center;
  align-items: center;
  cursor: pointer; 
  cursor: hand;
}
.btnName{
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.btnNameSelected{
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.selectedLine{
  margin-top: 5px;
  width: calc(100% / 68 * 21);
  padding-top: 3%;
  background: #6B834B;
  border-radius: 1px;
}
.trangle{
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 16px solid white;
  z-index: 999;
}
</style>
